import { BASE_URL, INDIAN_MSME_USER_TOKEN } from "../../utils/Constants";
import { RootState } from "..";
import axios from "axios";
import { ThunkAction } from "redux-thunk";
import POProductType, {
  acceptRejectPO,
  CancelOrderStatus,
  DeleteOrderItems,
  DeletePoProduct,
  GetPoList,
  GetPoProduct,
  OrderItems,
  Payment,
  RequestPoGenerate,
  UpdateDeliveryChargeAmount,
  UpdateLandingCost,
  UpdatePoProduct,
  UploadDDCProduct,
  UploadPoProduct,
  VendorList,
} from "../types/POProductType";
import { getCookie } from "../../utils/CookieAction";
import LogoutAction from "./LogoutAction";
import { toast } from "react-toastify";

interface Action {
  type: string;
  payload?: any;
  message?: string;
}

const POProductAction = {
  getPoProduct:
    (data: GetPoProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const getPoProductData: any = await axios.post(
          BASE_URL + "po_product/list",
          {
            search: data.search,
            limit: data.limit,
            page: data.page,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: POProductType.SET_PO_PRODUCT_LIST,
          payload: {
            data: getPoProductData.data.data.data,
            currentPage: getPoProductData.data.data.current_page,
            lastPage: getPoProductData.data.data.last_page,
            totalData: getPoProductData.data.data.total,
            from: getPoProductData.data.data.from,
            to: getPoProductData.data.data.to,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  updatePoProduct:
    (data: UpdatePoProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const updatePoProductData: any = await axios.post(
          BASE_URL + "po_product/update",
          {
            id: data.id,
            product_name: data.product_name,
            product_code: data.product_code,
            sku: data.sku,
            mrp: data.mrp,
            landing_cost: data.landing_cost,
            po_qty: data.po_qty,
            vendor_id: data.vendor_id,
            tax: data.tax,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );

        dispatch({
          type: "",
          payload: {
            type: "",
            status: updatePoProductData.data.status,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  deletePoProduct:
    (data: DeletePoProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const deletePoProductData: any = await axios.delete(
          BASE_URL + "po_product/delete/" + data.id,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          }
        );
        dispatch({
          type: "",
          payload: {
            status: deletePoProductData.data.status,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  uploadPoProduct:
    (data: UploadPoProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const poProductData: any = await axios.post(
          BASE_URL + "product/upload-csv-for-po-product",
          {
            excel_file: data.csv_file,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );

        dispatch({
          type: POProductType.SET_UPLOAD_CSV_FILE,
        });

        return poProductData.data;
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  requestPoGenerate:
    (data: RequestPoGenerate): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const result: any = await axios.post(
          BASE_URL + "po-generate/request",
          {
            delivery_charge: data.delivery_charge,
            terms: data.terms,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: POProductType.REQUEST_PO_GENERATE,
          });
          toast.success("PO Created Successfully");
        } else {
          toast.error(result.data.msg);
          return false;
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        } else if (error.response.status === 500) {
          toast.error(error.response.statusText);
        }
      }
    },

  createPoGenerate:
    (data: Payment): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const result: any = await axios.post(
          BASE_URL + "po-generate/create",
          {
            paymentReceipt: data.receipt,
            id: data.id,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: POProductType.CREATE_PO_GENERATE,
          });
          toast.success("Payment done successfully");
          setTimeout(function () {
            window.location.reload();
          }, 1500);
        } else {
          toast.error(result.data.msg);
          return false;
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        } else if (error.response.status === 500) {
          toast.error(error.response.statusText);
        }
      }
    },
  getPOList:
    (data: GetPoList): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "po-generate/list/",
          {
            poOrderStatus: data.poOrderStatus,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );

        dispatch({
          type: POProductType.PO_LIST,
          payload: result.data.data,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  getPOOrderItems:
    (data: OrderItems): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.get(
          BASE_URL + "po/order/items/" + data.id,
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              Accept: "application/json",
            },
          }
        );
        dispatch({
          type: POProductType.ORDER_ITEMS,
          payload: {
            data: result.data.data.items,
            total: result.data.data.total,
            poOrders: result.data.data.poOrders,
            grandTotal: result.data.data.grandTotal,
            totalWithMarginPrice: result.data.data.totalWithMarginPrice,
            totalTax: result.data.data.totalTax,
            totalSupplyQty: result.data.data.totalSupplyQty,
            userDetails: result.data.data.userDetails,
          },
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  deleteOrder:
    (data: DeleteOrderItems): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        await axios.get(BASE_URL + "po/order/delete/" + data.id, {
          headers: {
            Authorization: "Bearer " + JSON.parse(token),
            Accept: "application/json",
          },
        });

        dispatch({
          type: POProductType.DELETE_ORDER_ITEMS,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  acceptReject:
    (data: acceptRejectPO): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        await axios.post(
          BASE_URL + "po/orderAccept",
          {
            id: data.id,
            status: data.status,
            without_margin_price: data.without_margin_price,
            price: data.price,
            tax: data.tax,
            qty: data.qty,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          }
        );

        dispatch({
          type: POProductType.PO_ORDER_ACCEPTANCE,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
  vendorList:
    (data: VendorList): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const result: any = await axios.post(
          BASE_URL + "po-generate/vendor-list",
          {
            city: data.city,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          }
        );
        if (result.data.status) {
          dispatch({
            type: POProductType.PO_VENDOR_LIST,
            payload: result.data.data,
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        } else if (error.response.status === 500) {
          toast.error(error.response.statusText);
        }
      }
    },
  getSellerUniqueId:
    (): ThunkAction<void, RootState, null, Action> => async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);

        const result: any = await axios.get(
          BASE_URL + "po-generate/seller-unique-id",
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          }
        );

        if (result.data.status) {
          dispatch({
            type: POProductType.PO_SELLER_UNIQUE_LIST,
            payload: result.data.data,
          });
        }
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        } else if (error.response.status === 500) {
          toast.error(error.response.statusText);
        }
      }
    },

  uploadDDCProduct:
    (data: UploadDDCProduct): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        const poProductData: any = await axios.post(
          BASE_URL + "product/upload-csv-for-ddc-product",
          {
            excel_file: data.csv_file,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
              "Content-Type": "multipart/form-data",
            },
          }
        );

        dispatch({
          type: POProductType.SET_UPLOAD_DDC_CSV_FILE,
        });

        return poProductData.data;
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  updateDeliveryChargeAmount:
    (
      data: UpdateDeliveryChargeAmount
    ): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        await axios.post(
          BASE_URL + "po/update-delivery-charge",
          {
            id: data.id,
            delivery_charge: data.delivery_charge,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          }
        );

        dispatch({
          type: POProductType.SET_DELIVERY_CHARGE,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  CancleOrderItemStatus:
    (data: CancelOrderStatus): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        await axios.post(
          BASE_URL + "po/cancel-order-item",
          {
            id: data.id,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          }
        );

        dispatch({
          type: POProductType.CANCEL_ORDER_ITEM,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },

  updateLandingCost:
    (data: UpdateLandingCost): ThunkAction<void, RootState, null, Action> =>
    async (dispatch) => {
      try {
        const token: string | any = getCookie(INDIAN_MSME_USER_TOKEN);
        await axios.post(
          BASE_URL + "po/update-landing-cost",
          {
            id: data.id,
            landing_cost: data.landing_cost,
          },
          {
            headers: {
              Authorization: "Bearer " + JSON.parse(token),
            },
          }
        );

        dispatch({
          type: POProductType.UPDATE_LANDING_COST,
        });
      } catch (error: any) {
        if (error.response.status === 401) {
          dispatch(LogoutAction.logout());
        }
      }
    },
};

export default POProductAction;
